module.exports = __webpack_public_path__ + "static/spinner-72aeb60192df4cde55c9a825673f16a3.jpg";